module.exports = "<app-table-columns></app-table-columns>\r\n<app-table-headers\r\n    columns=\"$ctrl.columns.list()\"></app-table-headers>\r\n<app-table-row\r\n    ng-repeat=\"row in $ctrl.data track by $index\"\r\n    index=\"$index\"\r\n    data=\"row\"\r\n    columns=\"$ctrl.columns.list()\"></app-table-row>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/table/template.html
// module id = 2097
// module chunks = 0